export default "/assets/images/accessory-img-03.webp?c1d0bfdd229a82b24ea66c3134f98bff";